const RtlLanguages = ['fa', 'ar', 'per', 'ara'];

export { RtlLanguages };
